import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter,  Inject, Input, OnChanges, OnDestroy, OnInit, Optional, Output, PLATFORM_ID, Renderer2, SimpleChanges } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MEDIA_TOKEN } from '../../../../../tockens';

interface Item {
    name: string;
    code: string;
};

@Component({
    selector: 'clever-selectionlist',
    templateUrl: './selectionlist.component.html',
    styleUrls: ['./selectionlist.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class SelectionlistComponent implements OnInit, OnDestroy, OnChanges {
    @Input() mode: string = '';
    @Input() title: string = '';
    @Input() icon: string = '';
    @Input() currentItem: string = '';
    @Input() beliebig: boolean = true;
    @Input() tmpnorightborder: boolean = false;
    @Input() bottomleftradius: boolean = false;
    @Input() bottomrightradius: boolean = false;
    @Input() toprightradius: boolean = false;
    @Input() topleftradius: boolean = false;
    @Input() list: Item[] = [];
    @Output() triggerChange: EventEmitter<Item> = new EventEmitter();
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    media: string = 'lg';
    origin = 'default';
    zielText = '';
    minDauer: number;
    maxDauer: number;

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        if (this.currentItem?.length > 0) {
            this.zielText = this.currentItem;
        } else {
            this.zielText = this.title;
        }
        this.initMedia();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes['list']?.isFirstChange() && changes['list']?.currentValue) {
            this.list = changes['list'].currentValue;
        }
        if (!changes['currentItem']?.isFirstChange() && changes['currentItem']?.currentValue) {
            this.currentItem = changes['currentItem'].currentValue;
            this.zielText = this.currentItem;
        }
        this.cdr.detectChanges();
    }

    initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    openModal(ev) {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal() {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile() {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any) {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    selectValue(item) {
        if (item) {
            this.zielText = item.name;
        } else {
            this.zielText = this.title;
        }
        this.triggerChange.emit(item);
        this.currentItem = item;
        this.closeModal();
    }
}
